import { useState } from 'react'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { product_nodes_path } from '@/lib/routes'
import { sendJson, type TreeProps } from './api'

interface Props {
  parentId: string | null
  depth: number
  onCreated: (tree: TreeProps) => void
  onCancel: () => void
}

// One-line form that adds a group: Enter saves, Escape cancels.
export default function NewGroupRow({ parentId, depth, onCreated, onCancel }: Props) {
  const [name, setName] = useState('')
  const [errors, setErrors] = useState<string[]>([])
  const [busy, setBusy] = useState(false)

  async function save() {
    if (!name.trim() || busy) return
    setBusy(true)
    const res = await sendJson<TreeProps>(product_nodes_path(), 'POST', { name: name.trim(), parent_id: parentId })
    setBusy(false)
    if (res.ok && res.data) onCreated(res.data)
    else setErrors(res.errors)
  }

  return (
    <div className="px-3 py-1.5" style={{ paddingLeft: 12 + depth * 16 }}>
      <div className="flex items-center gap-2">
        <Input
          autoFocus
          value={name}
          placeholder="Group name"
          className="h-8 flex-1"
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') save()
            if (e.key === 'Escape') onCancel()
          }}
        />
        <Button size="sm" className="h-8" onClick={save} disabled={busy || !name.trim()}>Save</Button>
        <Button size="sm" variant="outline" className="h-8" onClick={onCancel}>Cancel</Button>
      </div>
      {errors.map((e) => <p key={e} className="mt-1 text-sm text-destructive">{e}</p>)}
    </div>
  )
}
